import { render, staticRenderFns } from "./itemAvailabilityNotification.component.vue?vue&type=template&id=42d306f0&"
import script from "./itemAvailabilityNotification.component.vue?vue&type=script&lang=js&"
export * from "./itemAvailabilityNotification.component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/raschi/Sites/item-availability-notification/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('42d306f0')) {
      api.createRecord('42d306f0', component.options)
    } else {
      api.reload('42d306f0', component.options)
    }
    module.hot.accept("./itemAvailabilityNotification.component.vue?vue&type=template&id=42d306f0&", function () {
      api.rerender('42d306f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/components/itemAvailabilityNotification.component.vue"
export default component.exports